import classNames from "classnames";
import styles from "./TextArea.module.scss";
import type { TextAreaSize } from "./TextArea.types";

const variantClassNames: Record<"primary", string> = {
    primary: styles.primary,
};

const sizeClassNames: Record<TextAreaSize, string> = {
    md: styles.md,
    lg: styles.lg,
    xl: styles.xl,
};

/** Builds the root chrome classes shared by parts and composed usage. */
export const getTextAreaRootClassName = ({
    variant,
    size,
    className,
}: {
    variant: "primary";
    size: TextAreaSize;
    className?: string;
}) =>
    classNames(
        styles.root,
        variantClassNames[variant],
        sizeClassNames[size],
        className,
    );
